import React from 'react'
import bowser from 'bowser'
import { connect } from 'react-redux'
import NoSleep from '../Utils/NoSleep'

// TODO: Re-enable on IOS after research to make sure that the hidden video never shows.
function useNoSleep() {
  return !bowser.msie && (bowser.tablet || bowser.mobile) && !bowser.ios
}

/**
 * Component that listens to the "playing" variable in the "base" state and
 * adds the "No-Sleep" functionality once its set to true.
 */
@connect(state => ({
  spinsLeft: state.autoPlay.spinsLeft,
  playing: state.base.playing
}))
export default class KeepAlive extends React.Component {
  constructor(props, context) {
    super(props, context)

    this.noSleep = useNoSleep() ? new NoSleep() : false
  }

  componentDidMount() {
    if (!this.noSleep) { return }

    if (this.props.playing) {
      window.addEventListener('touchend', this.readyTouch)
    }
  }

  componentWillReceiveProps(nextProps) {
    if (!this.noSleep) { return }

    if (nextProps.playing || nextProps.spinsLeft) {
      if (!this.enabled) {
        this.enabled = true
        this.noSleep.enable()
      }
    } else if (this.enabled) {
      this.enabled = false
      this.noSleep.disable()
    }
  }

  readyTouch = () => {
    this.componentWillReceiveProps(this.props)
  }

  render() {
    return <div />
  }
}
